<template>
  <div class="tinformation" v-wechat-title="$route.meta.title = title()">
    <div class="tinformation-header">

      <van-button class="left-button" color="#006EFF"  size="small" @click="goFilter">
        <span class="button-text">{{ $t('append_field.filter') }}</span>
      </van-button>
      <span class="header-title" v-if="environment==='local'">{{ $t('append_field.terminal') }}</span>
      <van-button class="right-button"  color="#006EFF" size="small"  @click="goTerminalList">
        <span class="button-text">{{ $t('append_field.deviceList') }}</span>
      </van-button>

    </div>
    <div class="tinformation-content">
      <div class="tinformation-device">
        <div class="btn-list" >
          <van-button v-for="(item, index) in terminalMenuItems"
                      :key="index" :name="index"
                      :class="['terminal-btn', { 'selected': selectedIndex === index }]"
                      icon="/static/images/etv-folder.png"
                      @click="loadDeviceList(index,item.id)">
            {{ truncatedName(item.name) }}
          </van-button>
        </div>
        <div class="btn-all" >
          <van-checkbox icon-size="24px"
                        v-if="data_m.length > 0"
                        v-model="isCheckAll"
                        label-position="left"
                        :isIndeterminate="isIndeterminate"
                        @change="checkAllChange()"
          >{{ $t('append_field.select_all') }}</van-checkbox>

        </div>
        <div class="scroll-m-li " ref="scrollContainer">
          <van-checkbox-group v-model="terminalSelect">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list
                  v-model="loading"
                  :finished="finished"
                  :finished-text="finishedText"
                  @load="onLoad"
              >
                <div v-for="(item, index) in data_m"
                     :key="index"
                     @click="toggleCheckbox(item)"
                     class="custom-checkbox">
                  <van-cell class="checkbox-content"

                            :icon="item.onlineState == '1' ? '/static/images/terminal/icon_dev_online.png' : '/static/images/terminal/icon_dev_disonline.png'">
                    <span class="ellipsis">{{ item.name }}</span>
                  </van-cell>
                  <van-checkbox
                      :class="['checkboxes-' + index, { 'custom-unchecked': !isChecked(item) }]"
                      :name="item.clNo + '-' + item.clId"
                      :checked="isChecked(item)"
                  />
                </div>
              </van-list>
            </van-pull-refresh>

          </van-checkbox-group>
          <van-empty
              v-if="data_m.length === 0"
              class="custom-image"
              image="/static/images/terminal/empty-img.png"
              :description="$t('append_field.data_empty')"
          />
        </div>

      </div>
      <div class="tinformation-order">
        <div class="orderList" >
          <van-swipe :loop="false" ref="swipe" class="custom-swipe">
            <van-swipe-item v-for="(page, index) in paginatedOperation" :key="index">
              <van-row gutter="20">
                <van-col span="8" class="operation-item" v-for="(item) in page" :key="item.id" @click="itemClick(item)">
                  <div class="operation-item">
                    <img :src="item.icIcon"/>
                  </div>
                  <div class="operation-title">
                    {{ item.icName }}
                  </div>
                </van-col>
              </van-row>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>

    <!--    弹窗区   -->
    <van-dialog v-model="dialogShow" :title="$t('append_field.volume_setting')"
                @confirm="onsubmit('5004')"
                :beforeClose="vBeforeClose"
                show-cancel-button>
      <div style="margin:60px 35px;display: flex;justify-content: center">
        <van-slider v-model="volume" @change="setvolume" :min="0"  :max="100" style="z-index: 1">
          <template #button>
            <div class="custom-button" >{{ volume }}</div>
          </template>
        </van-slider>
      </div>
    </van-dialog>
    <van-dialog
        v-model="dialogShow2"
        :title="dialogtitle"
        @confirm="onsubmit(itemCode)"
        show-cancel-button>
      <div style="margin:50px;display: flex;justify-content: center;align-items: center;">
        <img src="/static/images/terminal/instruct.png" style="height: 30px;width: 30px;margin-right: 10px">
        <span style="font-size: 18px !important;">{{ tipMsg }}</span>
      </div>
    </van-dialog>
    <van-dialog
        v-model="dialogShowSelected"
        :title="dialogtitle"
        @confirm="gotoInstruct"
        show-cancel-button>
      <div style="margin: 10px">
        <span>{{ $t('append_field.device_quantity') }} ：{{ selectedDevices.length }}</span>
      </div>
      <div class="selected_devices">
        <van-cell-group>
          <van-cell
              v-for="(item, index) in selectedDevices"
              clickable
              :key="index"
              :icon="item.onlineState == '1' ? '/static/images/terminal/icon_dev_online.png' : '/static/images/terminal/icon_dev_disonline.png'"
              :title="item.name"
          >
            <template #right-icon>
              <van-icon name="/static/images/terminal/del.png" @click.stop="removeDevice(item)" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-dialog>
    <!--通知弹窗-->
    <div  v-if="isPushNotice === 1" class="notif-overlay" >
      <div class="notification">
        <div class="notif-header">
          <h3 class="notif-title">{{ noticeTitle }}</h3>
        </div>
        <div class="notif-img">
          <img src="/static/images/terminal/notification.png" alt="" >
        </div>
        <div class="notif-content">
          <div class="notif-title">{{ $t('append_field.notif_title') }} ：</div>
          <div class="notif-msg">
            <ul>
              <li v-html="noticeContent"></li>
            </ul>
          </div>
        </div>
        <div class="notif-footer">
          <van-button style="color: black;border-top: 1px solid #B8B8B8;"  @click="gotoNotice">{{ $t('append_field.close') }}</van-button>
        </div>
      </div>
    </div>
    <!-- 筛选弹窗   -->
    <van-dialog
        v-model="showFilter"
        :title="$t('append_field.filter')"
        show-cancel-button
        :beforeClose="vBeforeClose"
        @confirm="onSearch"
        @cancel="showFilter=false"
    >
      <van-search
          v-model="clientName"
          :placeholder="$t('append_field.enter_search_keyword')"
          shape="round"
          @search="onSearch"
      >
      </van-search>
      <div style="margin-left:16px ">{{$t('append_field.terminal_status')}}</div>
      <div class="popup-btns">
        <van-radio-group v-model="selectedType">
          <van-cell-group>
            <van-cell
                v-for="(item, index) in typeOptions"
                clickable
                :key="index"
                @click="getType(item.value)"
                :title="item.label"
            >
              <template #right-icon>
                <van-radio :name="item.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
    <!--  监控弹窗  -->
    <van-popup
        v-model="show2"
        position="bottom"
        class="monitoring"
        :close-on-click-overlay="false"
        style="z-index: 1000"
    >
      <div class="popup-header">
        <span class="popup-title">{{$t('append_field.remote_monitor')}}</span>
        <van-icon name="close" @click="closeMonitor" class="popup-close-icon" />
      </div>
      <div class="popup-content">
        <img id="larger" :src="monitoring" alt="">
      </div>
    </van-popup>
    <van-overlay :show="show" style="z-index: 999">
      <div class="wrapper">
        <van-loading  size="40px" vertical >{{ loadingMsg }}</van-loading>
      </div>
    </van-overlay>
    <van-dialog
        v-model="scanConfirmShow"
        :title="scanConfirmTitle"
        show-cancel-button
        @confirm="handleScanConfirm"
        @cancel="handleScanCancel"
        class="scan-confirm-dialog">
      <div style="padding: 20px; text-align: center;">
        <p style="font-size: 16px; color: #333; margin-bottom: 10px;">{{ scanConfirmMessage }}</p>
      </div>
    </van-dialog>


  </div>
</template>

<script>
import qs from 'qs'
import { Toast} from 'vant'
import {vBeforeClose} from "@/utils/tool";
import Cookies from "js-cookie";
import {environment} from "../assets/js/user_environment";

import {mapState, mapMutations} from "vuex";
function decodeHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
export default {
  name: 'Tinformation',

  data() {
    return {
      isTime:'09:06',
      timeShow:false,
      timeShow2:false,
      activeName: 'a',
      id: 1,
      paginatedOperation: [],
      containerHeight: 0,
      operationVolume: [
        {
          icIcon: '/static/images/terminal/bindTask.png',
          icInstruction: '001',
          icName: this.$t('append_field.bind_task'),
          icType: 'client',
          id: 9,
        },
        {
          icIcon: '/static/images/terminal/remoteMonitor.png',
          icInstruction: '5010',
          icName: this.$t('append_field.remote_monitor'),
          icType: 'client',
          id: 11,
        },
      ],
      operation: [
        {
          icIcon: '/static/images/terminal/volume.png',
          icInstruction: '5004',
          icName: this.$t('append_field.adjust_volume'),
          icType: 'client',
          id: 1,
        },
        {
          icIcon: '/static/images/terminal/restart.png',
          icInstruction: '5007',
          icName: this.$t('append_field.reboot_device'),
          icType: 'client',
          id: 2,
        },
        {
          icIcon: '/static/images/terminal/awaken.png',
          icInstruction: '5020',
          icName: this.$t('append_field.wake_up'),
          icType: 'client',
          id: 3,
        },
        {
          icIcon: '/static/images/terminal/dormant.png',
          icInstruction: '5019',
          icName: this.$t('append_field.sleep'),
          icType: 'client',
          id: 4,
        },
        {
          icIcon: '/static/images/terminal/shutdown.png',
          icInstruction: '5018',
          icName: this.$t('append_field.shutdown'),
          icType: 'client',
          id: 5,
        },
        {
          icIcon: '/static/images/terminal/scheduleOnOff.png',
          icInstruction: '002',
          icName: this.$t('append_field.schedule_on_off'),
          icType: 'client',
          id: 10,
        },
        {
          icIcon: '/static/images/terminal/timing.png',
          icInstruction: '5012',
          icName: this.$t('append_field.clean_up_timing_on_off'),
          icType: 'client',
          id: 6,
        },

        {
          icIcon: '/static/images/terminal/clean.png',
          icInstruction: '5005',
          icName: this.$t('append_field.clean_up_disk'),
          icType: 'client',
          id: 7,
        },
        {
          icIcon: '/static/images/terminal/CleanTask.png',
          icInstruction: '5006',
          icName: this.$t('append_field.clean_up_task'),
          icType: 'client',
          id: 8,
        },



      ],
      dialogShow: false,
      volume: 70,
      dialogShow2: false,
      dialogtitle: this.$t('append_field.send_command'),
      tipMsg: '',
      itemCode: '',
      clNo: '',
      monitoring: require("../assets/images/image.png"),
      show: false,
      start_time: "",
      end_time: "",
      timeinfo: "",
      clientTaskInfo: [],
      isVisible4: false,
      time_type: "start_time",
      checkboxData: [
        {value: true, label: this.$t('append_field.mon')},
        {value: true, label: this.$t('append_field.tue')},
        {value: true, label: this.$t('append_field.wed')},
        {value: true, label: this.$t('append_field.thu')},
        {value: true, label: this.$t('append_field.fri')},
        {value: true, label: this.$t('append_field.sat')},
        {value: true, label: this.$t('append_field.sun')}
      ],
      group: [],
      checkall: true,
      isDisabled: true,
      show1: false,
      clientTaskInfos: [],
      shutdown_tips:'',
      show2:false,
      loadingMsg:'',
      terminalMenuItems:[],//设备分组
      selectedIndex: 0,  //选择的分组
      activeNames: '',
      terminalSelect: [],
      data_m: [],
      index: 0,
      checkedItems:[],
      showFilter:false,
      onlineState: '',
      clientName: '',
      typeOptions: [
        { value: '0', label: this.$t('append_field.all') },
        { value: '1', label: this.$t('append_field.online') },
        { value: '-1', label: this.$t('append_field.offline') },
      ],
      selectedType:'0',
      clientNos:[],
      ids:[],
      dialogShowSelected:false,
      selectedDevices:[],
      pushNotice:'-1',
      isPushNotice:0,//通知的标识
      isCheckAll:false,
      isIndeterminate:false,
      allData:[],
      scanConfirmShow: false, // 扫码确认弹窗
      scanConfirmTitle: this.$t('append_field.confirm_connect_device'), // 扫码确认弹窗标题
      scanConfirmMessage: '', // 扫码确认弹窗消息
      clientInfo:'',
      channel:'',
      environment,
      scanData: null, // 扫码数据
      showScanConnect: false, // 是否显示微信扫码组件
      showScanCodePage: false, // 是否显示H5扫码组件
      allDataList: [],
      pageSize: 20,
      pageNo: 1,
      groupParentId:1,
      loading: false,
      finished: false,
      refreshing: false,
      finishedText:"",
      noticeTitle:'',
      noticeContent:"",

    }
  },
  watch: {
    terminalSelect() {
      this.updateCheckAllState()
    },
    // 监听 store 中的扫码结果，统一处理“扫码连接”和本地缓存的连接
    scanResult(newVal) {
      if (!newVal) return

      let deviceName = ''

      // 来自新扫码组件：是一个对象，包含 data、channel、name 等字段
      if (typeof newVal === 'object') {
        const { data, channel, name } = newVal
        this.clientInfo = data || ''
        this.channel = channel || ''
        deviceName = name || ''

        // 将本次扫码结果缓存到 Cookie，作为“本地登录之后缓存的连接”
        if (this.clientInfo && this.channel && deviceName) {
          Cookies.set('clientInfo', this.clientInfo)
          Cookies.set('channel', this.channel)
          Cookies.set('deviceName', deviceName)
        }
      } else if (typeof newVal === 'string') {
        // 兼容旧逻辑：如果只是设备名称字符串
        deviceName = newVal
      }

      if (deviceName) {
        this.$nextTick(() => {
          this.handleScanCodeSuccess(deviceName)
        })
      }
    },
  },
  async created() {
    await this.$ajax.post('/etv/selectSysNoticeByType.json',qs.stringify({type: '1'})).then(res => {
      if (res.data.code === 0 && res.data.data) {
        let data = res.data.data
        this.noticeContent = decodeHtml(data.noticeContent)
        this.pushNotice = data.status
        this.noticeTitle = data.noticeTitle
        localStorage.setItem("displayFlag", data.displayFlag) //显示的频次
      }
    })
    this.isPushNotice = localStorage.getItem('isPushNotice') ? localStorage.getItem('isPushNotice') : this.pushNotice

  },
  mounted() {

    const tabbar = document.querySelector('.van-tabbar')
    tabbar.style.display = ''
    this.getTerinalList('','',1)
    this.calculatePagination()
    window.addEventListener('resize', this.calculatePagination)
    const deviceName = Cookies.get('deviceName')
    const clientInfo = Cookies.get('clientInfo')
    const channel = Cookies.get('channel')

    if(deviceName && clientInfo && channel && this.environment!=='local'){
      this.clientInfo = clientInfo
      this.channel = channel
      this.handleScanCodeSuccess(deviceName)
    }
  },
  methods: {
    vBeforeClose,
    ...mapMutations(['resetScanResult']),
    timeCancel(v){
      switch (v){
        case 0:
          this.timeShow = false
          break
        case 1:
          this.show1 = false
          this.end_time = ''
          this.start_time = ''
          break
        case 2:
          this.timeShow2 = false
          break
      }
      this.getDingshiInfo()
    },
    onConfirm2(value){
      this.start_time = value
      this.timeShow2 = false
    },
    onConfirm(value){
      this.end_time = value
      this.timeShow = false
    },


    onEdit() {
      this.show1 = true
    },
    setCheckbox(val) {
      let index = this.checkboxData.map(res => res.label).indexOf(val)
      this.checkboxData[index].value = !this.checkboxData[index].value

      this.$set(this.checkboxData, index, this.checkboxData[index])
      this.checkall = true

      for (let i = 0; i < this.checkboxData.length; i++) {
        if (!this.checkboxData[i].value) {
          this.checkall = false
          break
        }
      }
    },
    onDingshi() {
      if(!this.start_time||!this.end_time){
        Toast(this.$t('append_field.please_select_time'),'fail')
        return
      }
      // 检查是否至少选择了一个日期
      const isAnyDaySelected = this.checkboxData.some(day => day.value);
      if (!isAnyDaySelected) {
        Toast(this.$t('append_field.please_select_date'), 'fail');
        return;
      }
      this.$ajax.post("/etv/socket.json", qs.stringify({
        'instruction': 5012,
        'clientIdList': this.id,
        'onlineState': this.onlineState,
        'searchParam': this.clientName,

      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax({
            url: "/etv/insertTimedTask.json",
            method: "post",
            transformResponse: [function (data) {
              if (data instanceof FormData) {
                return data
              }
              data = qs.stringify(data)
              return data
            }],
            data: {
              clIdList: [this.id],
              timedTaskList: [
                {
                  ttMon: this.checkboxData[0].value,
                  ttTue: this.checkboxData[1].value,
                  ttWed: this.checkboxData[2].value,
                  ttThu: this.checkboxData[3].value,
                  ttFri: this.checkboxData[4].value,
                  ttSat: this.checkboxData[5].value,
                  ttSun: this.checkboxData[6].value,
                  ttOffTime: this.end_time,
                  ttOnTime: this.start_time,
                  checkall: this.checkall,
                }
              ],

            }
          }).then(res => {
            if (res.data.code === 0) {
              Toast({
                message: res.data.msg,
                icon: 'like-o',
              })
              this.getDingshiInfo()
            } else {
              Toast(res.data.msg,'fail')
            }
            this.show1 = false
          })
        }
      })
    },

    setvolume(val) {
      this.volume = val
    },

    onsubmit(icInstruction) {
      let data = {
        onlineState: this.onlineState,
        searchParam: this.clientName,
        clientIdList: this.ids,
        instruction: icInstruction,
      }
      if (icInstruction) {
        data.instruction = icInstruction
      } else {
        data.instruction = this.itemCode
      }

      if ('5004' === icInstruction) {
        data = {
          onlineState: this.onlineState,
          searchParam: this.clientName,
          clientIdList: this.ids,
          instruction: icInstruction,
          volNum: this.volume,
        }
      }

      this.$ajax.post('/etv/socket.json', data).then(res => {
        if (res.data.code === 0) {
          this.loadingMsg=res.data.msg
          this.show = true
          if (icInstruction === '5010') {
            setTimeout(() => {
              this.$ajax.post("/etv/selectByClientNo.json",  {
                clientIdList: this.ids,
              }).then(res => {
                if (res.data.code === 0) {
                  this.monitoring = res.data.data[0].monitorPath[0].eiSavePath
                  let w = $('#larger').width()
                  let h = $('#larger').height()
                  if (w / h > 1) {
                    $('#larger').width(320)
                    $('#larger').height('auto')
                  } else {
                    $('#larger').width('auto')
                    $('#larger').height(320)
                  }
                } else {
                  Toast({
                    message: res.data.msg,
                    duration: 2000, // 持续时间
                    position: 'top', // 显示在顶部
                  })
                }
              })

            }, 1000 * 10)
          }
        } else {
          Toast(res.data.msg,'fail')
        }
        this.dialogShow = false
        this.dialogShow2 = false
      })
      setTimeout(() => {
        this.$ajax.post("/etv/selectInstructionFailureSendState.json").then(res => {
          this.show = false
          if(icInstruction === '5010'){
            this.show2=true
          }
          if (res.data.code === 0) {
            if(res.data.data.successCount===0){
              Toast({
                message:this.$t('append_field.device_not_online_please_retry'),
                duration: 2000, // 持续时间
                position: 'top', // 显示在顶部
              })
            }else {
              Toast({
                message:this.$t('append_field.sent_successfully'),
                duration: 2000, // 持续时间
                position: 'top', // 显示在顶部
              })
            }

          } else {
            Toast(res.data.msg)
          }
        })
      }, 1000 * 5)
    },
    itemClick(res) {
      let terminalSelectedArr = this.selectedDevices
      this.ids=[]
      this.clientNos=[]
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        this.ids.push(terminalSelectedArr[i].clId)
        this.clientNos.push(terminalSelectedArr[i].clNo)
      }
      if(this.clientNos.length < 1 || this.ids < 1){
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      //不在线的设备不能下发指令
      /* const isAnyDeviceOffline = this.selectedDevices.some(device => device.onlineState === "-1")
       if (isAnyDeviceOffline) {
         Toast(this.$t('append_field.device_offline'))
         return;
       }*/
      switch (res.icInstruction) {
        case '001':
          if(this.clientNos.length === 1){
            this.$router.push({path: '/taskInfo', query: {id: this.ids[0], clNo: this.clientNos[0]}})
          }else {
            Toast(this.$t('append_field.selectDeviceOne'))
          }
          break
        case '002':
          if(this.clientNos.length === 1){
            this.$router.push({path: '/scheduleOnOff', query: {id: this.ids[0], clNo: this.clientNos[0]}})
          }else {
            Toast(this.$t('append_field.selectDeviceOne'))
          }
          break;
        case '5004':
          this.dialogShowSelected = true
          this.itemCode = res.icInstruction
          this.dialogtitle=this.$t('append_field.select_device_list')
          break;
        case '5010':
          if(this.clientNos.length === 1){
            this.dialogShow2=true
            if(res.icName===this.$t('append_field.shutdown')){
              this.shutdown_tips=this.$t('append_field.shutdown_tips')
            }else {
              this.shutdown_tips=''
            }
            this.tipMsg =this.shutdown_tips+ ' '+ this.$t('append_field.confirm2')+ ' ' + res.icName + '?'
            this.itemCode = res.icInstruction
          }else {
            Toast(this.$t('append_field.selectDeviceOne'))
          }
          break;
        default:
          this.dialogShowSelected = true
          this.dialogtitle=this.$t('append_field.select_device_list')
          if(res.icName===this.$t('append_field.shutdown')){
            this.shutdown_tips=this.$t('append_field.shutdown_tips')
          }else {
            this.shutdown_tips=''
          }
          this.tipMsg =this.shutdown_tips+ ' '+ this.$t('append_field.confirm2')+ ' ' + res.icName + '?'
          this.itemCode = res.icInstruction
      }

    },
    title() {
      switch (this.activeName) {
        case 'a':
          return this.$t('append_field.terminal_information')
        case 'b':
          return this.$t('append_field.terminal_operation')
        case 'c':
          return this.$t('append_field.bind_task')
        case 'd':
          return this.$t('append_field.schedule_on_off')
      }
    },
    goTerminalList(){
      this.$router.push({path: '/information'})
    },
    //指令列表分页
    calculatePagination() {
      const itemsPerPage = 6; // 每页固定显示6个项目（两行，每行三个）
      this.paginatedOperation = this.paginate(this.operation.concat(this.operationVolume), itemsPerPage);
    },
    paginate(array, itemsPerPage) {
      const paginatedArray = [];
      for (let i = 0; i < array.length; i += itemsPerPage) {
        paginatedArray.push(array.slice(i, i + itemsPerPage));
      }
      return paginatedArray;
    },
    getTerinalList( onlineState,clientName,groupParentId ) {
      this.loadingMsg=this.$t('append_field.loadinga')
      this.show = true
      this.terminalSelect = []
      this.selectedDevices = []
      this.$ajax.post('/etv/selectDeviceTree.json').then(res => {
        if (res.data.code === 0) {
          let arr = res.data.data[0].children

          this.terminalMenuItems = arr

          // 默认加载第一个按钮的设备列表
          if (this.terminalMenuItems.length > 0) {
            this.searchMobileDeviceTree(onlineState,clientName,groupParentId)
          }
        }else {
          Toast(res.data.msg)
        }


        this.show = false
      })
    },
    loadDeviceList(index,groupParentId) {
      this.isCheckAll = false
      this.terminalSelect = []
      this.selectedDevices = []
      this.activeNames = index
      this.index = 0
      this.selectedIndex = index
      this.groupParentId = groupParentId
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer
        if (el) {
          el.scrollTop = 0
        }
      })
      this.searchMobileDeviceTree(this.onlineState, this.clientName,groupParentId)
    },
    searchMobileDeviceTree(onlineState,clientName,groupParentId) {
      this.$ajax.post('/etv/searchMobileDeviceTree.json',qs.stringify({
        onlineState:onlineState,
        clientName:clientName,
        groupParentId:groupParentId,
      })).then(res => {
        if (res.data.code === 0) {
          this.allDataList = Array.isArray(res.data.data) ? res.data.data : []
          this.pageNo = 1
          this.data_m = this.allDataList.slice(0, this.pageSize)
          if(this.allDataList.length === 0){
            this.finishedText = ''
          }else {
            this.finishedText = this.$t('append_field.noMore')
          }
          this.finished = this.data_m.length >= this.allDataList.length
          this.isCheckAll = false
          this.isIndeterminate = false
          this.$nextTick(() => {
            this.showLoading = false
            const el = this.$refs.scrollContainer
            if (el) {
              el.scrollTop = 0
            }
          })
        }else {
          Toast(res.data.msg)
        }

      })
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },

    toggleCheckbox(item) {
      const name = `${item.clNo}-${item.clId}`
      const index = this.terminalSelect.indexOf(name)
      if (index > -1) {
        // 如果已经选中，则取消选中
        this.terminalSelect.splice(index, 1)
        // 从 selectedDevices 中移除对应设备
        this.selectedDevices = this.selectedDevices.filter(device => device.clId !== item.clId)
      } else {
        // 如果未选中，则选中
        this.terminalSelect.push(name)
        // 检查 selectedDevices 中是否已经存在该设备，避免重复添加
        if (!this.selectedDevices.some(device => device.clId === item.clId)) {
          this.selectedDevices.push(item)
        }
      }
      this.updateCheckAllState()
    },
    isChecked(item) {
      const name = `${item.clNo}-${item.clId}`
      return this.terminalSelect.includes(name)
    },
    checkAllChange() {
      if (this.isCheckAll) {
        // 全选
        this.terminalSelect = this.allDataList.map(item => `${item.clNo}-${item.clId}`)
        this.selectedDevices = [...this.allDataList]
      } else {
        // 取消全选
        this.terminalSelect = []
        this.selectedDevices = []
      }
      this.updateCheckAllState()
    },
    updateCheckAllState() {
      const total = this.allDataList.length
      const checkedCount = this.terminalSelect.length
      if (total === 0) {
        this.isCheckAll = false
        this.isIndeterminate = false
        return
      }
      this.isCheckAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },

    //筛选
    goFilter(){
      this.showFilter=true
    },
    getType(type) {
      this.selectedType = type
      this.onlineState = type
    },
    onSearch() {
      this.getTerinalList(this.onlineState, this.clientName,this.groupParentId)
      this.showFilter = false
    },
    gotoInstruct(){
      if(this.selectedDevices.length < 1){
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      this.dialogShowSelected=false
      this.dialogtitle= this.$t('append_field.send_command')
      if(this.itemCode==='5004'){
        this.dialogShow=true
      }else {
        this.dialogShow2=true
      }

    },
    removeDevice(item) {
      // 从 selectedDevices 中移除 item
      this.selectedDevices = this.selectedDevices.filter(device => device.clId !== item.clId)
      // 从 terminalSelect 中移除对应的 name
      const name = `${item.clNo}-${item.clId}`
      const index = this.terminalSelect.indexOf(name)
      if (index > -1) {
        this.terminalSelect.splice(index, 1)
      }
    },
    gotoNotice() {
      this.isPushNotice = 0
      localStorage.setItem('isPushNotice', this.isPushNotice)
    },
    closeMonitor(){
      this.show2 = false
      this.monitoring = require("../assets/images/image.png")
    },
    handleScanCodeSuccess(deviceName) {

      // 使用nextTick确保DOM已更新，再显示弹窗
      this.$nextTick(() => {
        this.scanConfirmTitle = this.$t('append_field.confirm_connect_device')
        this.scanConfirmMessage = this.$t('append_field.confirm_connect_device_msg',{deviceName: deviceName})
        this.scanConfirmShow = true

      })
    },
    handleScanConfirm() {
      if (!this.clientInfo) {
        Toast(this.$t('append_field.data_lost_rescan'))
        this.scanConfirmShow = false
        // 清除本地缓存，避免下次重复弹出
        Cookies.remove('deviceName')
        Cookies.remove('clientInfo')
        Cookies.remove('channel')
        this.resetScanResult()
        return
      }
      // 调用接口
      this.$ajax.post('/etv/scanCodeRegister.json', qs.stringify({
        clientInfo: this.clientInfo
      })).then(res => {
        if (res.data.code === 0) {
          Toast( res.data.msg)
          this.scanConfirmShow = false
        } else {
          Toast(res.data.msg)
        }
        Cookies.remove('deviceName')
        Cookies.remove('clientInfo')
        Cookies.remove('channel')
        this.resetScanResult()
      }).catch(error => {
        console.error('扫码注册失败:', error)
        Toast('连接失败，请重试')
      })
    },
    // 取消连接设备
    handleScanCancel() {
      this.scanConfirmShow = false
      Cookies.remove('deviceName')
      Cookies.remove('clientInfo')
      Cookies.remove('channel')
      this.resetScanResult()
    },

    handleScanConnect() {
      // 检测是否在微信浏览器中
      const ua = navigator.userAgent.toLowerCase()
      const isWeChat = /micromessenger/.test(ua)

      if (isWeChat) {
        // 在微信环境中，显示扫码组件并自动触发微信扫码
        this.showScanConnect = true
      } else {
        // 不在微信环境中，跳转到扫码连接1（H5扫码）
        this.showScanCodePage = true
      }
    },
    // 处理扫码完成事件
    handleScanComplete() {
      // 立即隐藏扫码组件，确保组件先关闭
      this.showScanConnect = false
      this.showScanCodePage = false
    },
    // 处理扫码组件取消事件
    handleScanConnectCancel() {
      // 隐藏扫码组件
      this.showScanConnect = false
      this.showScanCodePage = false
    },
    onLoad() {
      if (this.finished) {
        this.loading = false
        return
      }
      const nextPageNo = this.pageNo + 1
      const end = nextPageNo * this.pageSize
      const nextList = this.allDataList.slice(0, end)

      this.data_m = nextList
      this.pageNo = nextPageNo
      this.loading = false
      this.finished = this.data_m.length >= this.allDataList.length

    },
    onRefresh() {
      this.selectedType = '0'
      this.clientName = ''
      this.searchMobileDeviceTree('','',this.groupParentId)
      this.refreshing = false


    },
  },
  computed: {
    ...mapState({
      scanResult: state => state.scanResult,

    }),
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.tinformation {
  height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  /*background-color: #f2f2f2;*/
  .tinformation-header {
    height: 55px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    /*background-color: #006EFF;*/
  }

  .header-title {
    text-align: center;
    font-size: 20px !important;
    color: #000000;
  }


  .left-button {
    left: 10px;
  }

  .right-button {
    position: relative;
    display: flex;
    right: 10px;
    gap:15px;

  }

  .button-text {

    border-radius: 5px;
  }

  .tinformation-content{
    height: calc(100% - 55px );
    display: flex;
    flex-direction: column;
    background: #F2F2F2;
    .tinformation-device {
      height: calc(100% - 220px);
      display: flex;
      flex-direction: column;
      background-color: #ffffff;
      color: #000000;
      [class*=van-hairline]::after{
        border: none;
      }
      .van-icon__image{
        width: 20px;
        height: 20px;
        margin-left: 10px;

      }

      .item-row{
        height: calc(100% - 44px);
        display: flex;
        align-items: center;
        justify-content: center;
        .van-empty__image{
          width: 120px;
          height: 90px;
          margin-bottom: 20px;
        }
        .van-empty__description{
          color: #000000;
          font-size: 16px;
        }


      }
      .clientInfo {
        display: -webkit-box;
        width: 100%;
        height: 100%; /* 确保容器有高度 */
      }

      .left {
        flex: 1; /* 占据1/3 */
        display: flex;
        align-items: center; /* 垂直居中 */
        justify-content: center; /* 水平居中 */
      }

      .large-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover; /* 保持图像的比例 */
      }

      .right {
        flex: 2; /* 占据2/3 */
        display: flex;
        flex-direction: column;
        justify-content: space-between; /* 等间距分布 */
      }

      .van-cell {
        background-color: #ffffff;
        color: #000000;
        padding:5px 18px;
        .van-cell__value{
          color: #000000;
        }
        .van-cell__title {
          flex: 1;
          white-space: nowrap;
        }

        .ifctop {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 10px;
          margin-right: 5px;
          background: #ff0000;
        }

        .ifc {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 10px;
          margin-right: 5px;
          /*background: #006EFF;*/
        }

        .van-cell__value {
          flex: 2;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .btn-list{
        display: flex;
        overflow-y: auto;
        align-items: center;
        justify-content: flex-start;
        gap: 10px; /* 按钮之间的间隔 */
        margin:  10px 10px;

        .terminal-btn{
          flex: 1 1 auto; /* 自适应宽度 */
          white-space: nowrap; /* 防止文字换行 */
          background-color: white;
          color: black;
          border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
          .van-button__text{
            max-width: 100%;
          }
        }

        .selected {
          background-color: #006EFF ;
          color: white;

        }
      }
      .btn-all{
        margin: 0 10px;
        .van-checkbox{
          display: flex;
          justify-content: space-between;
        }
        .van-checkbox__icon .van-icon{
          border: 1px solid #000000;
        }
      }
      .scroll-m-li {
        flex: 1;
        overflow-y: auto;
        margin: 0 10px;
        .van-cell__value--alone{
          margin-left: 10px;
        }
        .van-checkbox{
          overflow: initial;
        }
        .van-icon{
          width: 1.5em;
          height: 1.5em;
          line-height:1.5;
        }
        .van-checkbox-group{
          width: 100%;
        }
        .custom-checkbox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
        }
        .custom-unchecked .van-checkbox__icon .van-icon {
          background-color: white !important;
          border-color: #000000 !important;
        }

        .custom-unchecked .van-checkbox__icon .van-icon::after {
          border-color: transparent !important;
        }
        .checkbox-content {
          display: flex;
          align-items: center;
          .ellipsis {
            display: block;
            max-width: 200px; /* 根据需要调整宽度 */
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top; /* 确保文本对齐 */
          }
          .van-cell__left-icon{
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .van-icon__image{
            width: 40px;
            height: 40px;
          }

        }

      }

    }

    .tinformation-order {
      display: flex;
      flex-direction: column;
      .orderList {
        position: relative;
      }

      .custom-swipe {
        margin-top: 12px;
        height: 195px;
        position: relative;
        padding-bottom: 0px; /* 给指示器留出空间 */
      }

      .van-swipe__track {
        height: 100%;
        overflow-y: auto;
        display: flex;
        align-items: flex-start;
        justify-content: center;
      }

      .van-swipe__indicators {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .van-swipe__indicator{
        background-color: #858383;
      }
      .van-swipe__indicator--active{
        background-color: #006EFF;
      }
      .van-row {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0 !important;
      }

      .operation-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 8px;
        text-align: center;
        font-size: 15px;
      }

      .operation-item img {
        width: 53px;
        height: 53px;
      }

      .operation-item:nth-last-child(1) {
        padding-left: 0px !important;
      }

      .operation-title {
        width: 105px;
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      }
    }
  }




  .edit-dialog{
    .van-field__body{
      border-bottom: black 1px solid;
    }

    .van-cell__value{
      flex: 7;
    }
  }

  .van-overlay {
    z-index: 999 !important;

    .wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-loading__text{
        color: #cccccc;
        font-size: 16px;
        font-weight: bold;
      }
      .block {
        color: #cccccc;
      }
    }
  }

  .empty {
    height: 100px;
    width: 100%;
    text-align: center;
    line-height: 100px;
    color: #8c8c8c;
  }

  .van-tabs {
    height: 100%;
  }

  .van-tabs__content {
    height: calc(100% - 44px);
    overflow-y: auto;
  }

  .van-cell-group{
    /*background-color: #006EFF;*/
    color: #FFFFFF;
  }

  .van-slider{
    height: 4px;
  }

  .custom-button {
    border-radius: 100%;
    height: 33px;
    width: 33px;
    border: 1px solid #ffffff;
    font-size:  16px;
    background: #006EFF;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }

  .nut-dialog-content {
    overflow: hidden;
  }

  .clientTaskInfoContent {
    height:100%;

    .clientTaskInfoBlock {
      margin-bottom: 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      background: #fff;
      font-size:  15px;

      .clientTaskInfoItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid $uni-bg-color-title;
        padding: 10px 15px 10px 20px;
        box-sizing: border-box;

        .clientTaskInfo_key {
          width: auto;
          display: flex;
          align-items: center;

          .clientTaskInfo_key_icon {
            height: 10px;
            width: 10px;
            border-radius: 100%;
            background: #006EFF;
            margin-right: 5px;
          }

        }

        .clientTaskInfo_val {
          color: #969696;
          flex: 1;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .cycleList {
          display: flex;
          width: 100%;

          .cycleItem {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            width: 100%;

            .weekli {
              width: 25px;
              height: 25px;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
              background: #fff;
              color: #006EFF;
              border: 1px solid #006EFF;
            }

            .istrue {
              background: #006EFF;
              color: #fff;

            }
          }
        }
      }

      .clientTaskInfoItem:last-child {
        border-bottom: none;
      }

      .btnList {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-right: 20px;
        box-sizing: border-box;

        .btn {
          display: flex;
          flex: 0 0 auto;
          height: 27px;
          line-height: 27px;
          background: #006EFF;
          margin: 10px 0 10px 10px;
          width: 50px;
          justify-content: center;
          border-radius: 5px;
          color: #fff;


          &.btn-delete {
            background: #fff;
            color: red;
            border: 1px solid red;
          }
        }
      }
    }
  }

  .dingshi {
    padding: 30px 0 10px 0;
    box-sizing: border-box;
    background: white;
    .custom-field .van-field__control {
      color: #333333;
    }
    .yes {
      background: #006EFF;
      color: #fff;
    }

    .no {
      background: #dadada;
      color: #333333;
    }

    .nut-textinput-disabled input {
      background-color: white;
    }

    .nut-textinput {
      padding: 0 16px;
      border-bottom: 1px solid #dddfe6;
    }

    .nut-textinput input {
      border: none;
      border-radius: 0;
      padding: 0 !important;
      text-align: right;
    }
  }

  .monitoring{
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: center;
    .popup-header {
      background: #F2F2F2;
      height: 40px;
      display: flex;
      justify-content: center; /* 使标题居中 */
      align-items: center; /* 垂直居中对齐 */
      position: relative; /* 为绝对定位的关闭图标提供参照 */
      padding: 10px 15px 5px 15px;
      font-size: 32px !important;
    }

    .popup-title {
      font-size: 18px !important;
      flex: 1; /* 占据剩余空间 */
      text-align: center; /* 确保文字在中间 */
    }

    .popup-close-icon {
      position: absolute;
      right: 10px; /* 根据需要调整右边距 */
    }
    .popup-content {
      height: 340px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center; /* 如果你希望图片在中间 */
      /*.van-image-preview{
        position: fixed;
        top: 50%;
        left: 0;
        width: 100%;
        height: 340px;
      }*/
      img{
        max-height: 320px;
        max-width: 320px;
      }
    }
  }

  .selected_devices{
    height: 250px;
    overflow-y: auto;
    .van-cell__title{
      display: flex;
      align-items: center;

      span{
        display: block;
        width:200px; /* 使文本占满按钮宽度 */
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      }
    }
    .van-icon__image{
      width: 40px;
      height: 40px;
    }
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }
  .notif-overlay {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .notification{
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 4px ;
    width: 100%;
    .notif-header {
      display: flex;
      font-size: 18px;
      font-weight: bold;
      padding: 12px 20px ;
      justify-content: center;
      align-items: center;
      background: #F2F2F2 !important;
    }
    .notif-title {
      font-size: 18px;
    }
    .notif-img{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        height: 150px;
        width: 150px;
      }
    }
    .notif-content{
      padding: 10px;
      background: #fff;
      .notif-msg{
        padding: 10px;
        max-height: 200px;
        overflow: auto;
        color: red;
        line-height: 30px;
        text-align: justify;

      }
    }
    .notif-footer {
      display: flex;
      justify-content: space-between;

      background: #F2F2F2 ;
      .van-button {
        height: 48px !important;
        background: #F2F2F2 ;
        border-radius: 0 !important;
        flex: 1;
      }
    }
  }
}
</style>
